<template>

  <div class="flex h-screen">
    <div class="m-auto">
      <div class="text-4xl">Obrigado pela sua participação!</div>
    </div>
  </div>
</template>

<script>
import ButtonPrimary from '@/Components/ButtonPrimary';
export default {
  components: { ButtonPrimary },
  data() {
    return {
      form: this.$inertia.form({
        codigo_acesso: null
      })
    }
  },
  methods: {
    save() {
      this.form.post(this.route('entrevista-colaborador.dologin'));
    }
  }
}
</script>

<style>
</style>
